import 'flag-icon-css/css/flag-icon.css';

import { ChallengeResult, closeChallengeDialog } from '../../../modules/challenge';
import { CircularProgress, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../../modules';
import React, { Component, FormEvent, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { queryAuthStatus, challenge as soapChallenge } from '../../../modules/api';

import Button from '@material-ui/core/Button';
import ChallengeRequestProps from './ChallengeRequestProps';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { PhoneNumberEnrolment } from '../../../components/PhoneNumberInput';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { enrolmentToContactList } from '../../../helpers/credentials/OobPhone';

const styles = (theme: Theme) => createStyles({
  progress: {
    display: 'block',
    margin: `${theme.spacing(2)}px auto`,
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  error: {
    color: theme.palette.error.main
  },
  contactList: {
    maxWidth: theme.spacing(50),
    margin: `0 auto`,
  },
  contact: {
    cursor: 'pointer',
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  chevron: {
    marginLeft: theme.spacing(2),
  },
})

type State = {
  loading: boolean
  enrolments: PhoneNumberEnrolment[]
  selectedEnrolment: PhoneNumberEnrolment | null
  statusCode: string
  token: string
  error: string
};

class OobPhoneChallengeRequest extends Component<Props, State> {


  constructor(props: Props) {
    super(props)
    let enrolments = this.props.authmethods.oobPhone.enrolments

    this.state = {
      loading: true,
      enrolments,
      selectedEnrolment: null,
      statusCode: "",
      token: "",
      error: "",
    }
  }

  componentWillMount() {
    this.setState({ loading: false })
  }

  handleChallengeContact(pne: PhoneNumberEnrolment) {
    const { challenge } = this.props

    let args = {
      credentialChallengeRequestList: {
        oobPhoneChallengeRequest: {
          payload: {
            noOp: false,
            phoneInfo: enrolmentToContactList(pne)[0],
            tokenCollectionFlow: true,
          }
        }
      },
      eventDataList: {
        eventData: {
          eventType: challenge.analyzeRequest.eventDataList.eventData.eventType
        }
      }
    }

    this.setState({
      selectedEnrolment: pne,
      loading: true,
    })
    this.props.soapChallenge(args).then((data: any) => {
      try {
        let callStatus = data.credentialChallengeList.oobPhoneChallenge.payload.callStatus

        if (callStatus.statusCode !== "SUCCESS")
          throw new Error("Received response status code: " + callStatus.statusCode)

        this.setState({
          loading: false,
          statusCode: callStatus.statusCode,
          token: data.credentialChallengeList.oobPhoneChallenge.payload.token
        })
      } catch (error) {
        console.error(error)
        this.setState({ selectedEnrolment: null, loading: false, error: "Error sending challenge request" })
      }
    }).catch((error: Error) => {
      console.error(error)
      this.setState({ selectedEnrolment: null, loading: false, error: "Error sending challenge request" })
    })
  }

  handleQueryAuthStatus = (e: FormEvent) => {
    e.preventDefault()

    const { token } = this.state

    let args = {
      credentialAuthStatusRequest: {
        oobPhoneAuthStatusRequest: {
          payload: {
            token
          }
        }
      }
    }
    this.props.queryAuthStatus(args)
      .then((data: any) => {
        if (data.credentialAuthStatusResponse.oobPhoneAuthStatusResponse.payload.authenticationResult.authStatusCode === "SUCCESS") {
          this.props.challengeResponse(ChallengeResult.Success)
        }
        else {
          this.props.challengeResponse(ChallengeResult.Failure)
        }
      }).catch((error: Error) => {
        this.props.challengeResponse(ChallengeResult.Error)
      })
  }

  handleBack = () => {
    if (this.state.selectedEnrolment == null)
      this.props.challengeResponse(ChallengeResult.Pending)
    else {
      this.setState({ selectedEnrolment: null })
    }
  }

  maskedNumber(pne: PhoneNumberEnrolment) {
    let pn = pne.phoneNumber
    let maskedNumber = pn.getNumber('international')
    let extract = maskedNumber.match(/^(\S+)(.*)((?:\d\D?){4})$/)

    if (extract && extract.length > 2)
      maskedNumber = extract[1] + extract[2].replace(/\d/gi, 'x') + extract[3]
    return maskedNumber
  }

  renderContact = (c: PhoneNumberEnrolment) => {
    const { classes } = this.props

    return (
      <ListItem key={c.key} className={classes.contact} button onClick={() => this.handleChallengeContact(c)}>
        <ListItemIcon>
          {
            <span className={classnames("flag-icon", c.phoneNumber.isValid() ? `flag-icon-${c.phoneNumber.getRegionCode().toLowerCase()}` : "flag-icon-hidden")}></span>
            /*<FontAwesomeIcon icon={faMobileAlt} fixedWidth size="2x" />*/
          }
        </ListItemIcon>
        <ListItemText inset primary={this.maskedNumber(c)} />
        <FontAwesomeIcon icon={faChevronRight} size="1x" className={classes.chevron} />
      </ListItem>
    )
  }
  render() {
    const { loading, error, enrolments, selectedEnrolment, token } = this.state
    const { classes } = this.props

    return (
      <Fragment>
        {loading && !error &&
          <CircularProgress className={classes.progress} />
        }

        {!loading && selectedEnrolment === null &&
          <Fragment>
            <DialogContent>
              <Typography className={classes.error}>{error}</Typography>
              <DialogContentText>
                Select a phone number to receive your OTP on:
              </DialogContentText>
              <List className={classes.contactList}>
                {enrolments.map(this.renderContact)}
              </List>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <div></div>
              <Button onClick={this.handleBack} color="primary">
                <FontAwesomeIcon icon={faChevronLeft} />&nbsp; Back
              </Button>
            </DialogActions>
          </Fragment>
        }

        {!loading && selectedEnrolment !== null &&
          <Fragment>
            <DialogContent>
              <Typography className={classes.error}>{error}</Typography>
              <DialogContentText>
                You will be receiving a phone call shortly at {this.maskedNumber(selectedEnrolment)}. When prompted, enter the token code below on your phone's keypad. Once completed, click "Authenticate".
              </DialogContentText>
              <Typography variant="h4" align="center" style={{ marginTop: '1rem' }}>{token}</Typography>

            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.handleQueryAuthStatus} color="primary">
                Authenticate
              </Button>
              <Button onClick={this.handleBack} color="primary">
                Back
              </Button>
            </DialogActions>
          </Fragment>
        }
      </Fragment>
    )
  }
}


const mapStateToProps = ({ auth, authmethods, challenge }: IStoreState) => ({
  auth,
  authmethods,
  challenge
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      soapChallenge,
      queryAuthStatus,
      closeChallengeDialog
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, ChallengeRequestProps {
  // refer to ChallengeRequestProps.ts
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OobPhoneChallengeRequest));